
// TYPES
export const types = {
    FETCH_ADRRESSES: "ADDRESS/FETCH_ADRRESSES",
};

// INITIAL STATE
export const initialState = {
    data: [],
    loading: false,
    error: null,
};

// REDUCER
export default (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_ADRRESSES + "/REQUEST":
            return {
                ...state,
                loading: true
            };
        case types.FETCH_ADRRESSES + "/SUCCESS":
            return {
                ...state,
                loading: false,
                data: action.data.data
            };

        default:
            return state
    }
}

// ACTIONS
export const actions = {

    fetchAddresses: () => {
        return {
            type: types.FETCH_ADRRESSES,
            $fetch: {
                url: '/api/v1/addresses',
                method: 'GET'
            }
        };
    },
};